// src/hooks/useBrandQuery.ts
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { BrandService, Brand } from '../Services/brandService';

export const BRAND_QUERY_KEYS = {
  all: ['publicBrands'] as const,
  allBrands: () => ['publicBrands', 'all'] as const,
};

async function fetchAllBrands(): Promise<Brand[]> {
  return BrandService.getAllBrands();
}

export const useAllBrandsQuery = () => {
  return useQuery({
    queryKey: BRAND_QUERY_KEYS.allBrands(),
    queryFn: fetchAllBrands,
    staleTime: 1000 * 60 * 10,
  });
};

export const useInvalidateBrands = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: BRAND_QUERY_KEYS.all });
};